'use memo'

import {
  AgxButton,
  Icon_Email,
  Icon_PhoneOutline,
  type IColumnConfig,
  type RowData,
} from '@urbanx/agx.ui-components2'
import IconText from 'components/icon-text/IconText'
import type { AgencySupplier } from '@urbanx/agx.agencies.client'

const columnConfig = [
  { name: 'Company Name', maxColWidth: '18%' },
  { name: 'Email', maxColWidth: '22%' },
  { name: 'Phone', maxColWidth: '18%' },
  { name: 'Note' },
  { name: 'Actions', hideHeader: true, align: 'right', shrink: true },
] satisfies IColumnConfig[]

const useAgencySupplierTableConfig = (
  suppliers: AgencySupplier[],
  editSupplierClick: (index: number) => void
): [IColumnConfig[], RowData[]] => {
  const rows = suppliers.map((supplier, index) => ({
    'Company Name': supplier?.companyName,
    Email: (
      <IconText
        icon={<Icon_Email width={22} height={22} color="#b9b9b9" />}
        text={supplier?.email?.address ?? ''}
        wordBreak="break-all"
      />
    ),
    Phone: (
      <IconText
        icon={<Icon_PhoneOutline width={22} height={22} color="#b9b9b9" />}
        text={supplier?.phone?.number ?? ''}
      />
    ),
    Note: supplier?.notes,
    Actions: (
      <AgxButton
        id={`supplier-edit-${index}`}
        text="Edit"
        variant="hollow"
        size="medium"
        onClick={() => editSupplierClick(index)}
      />
    ),
    dataTestId: `supplier-${index}`,
  }))

  return [columnConfig, rows]
}

export default useAgencySupplierTableConfig
